import IHashService from "./IHashService";
// Rusha has no TS types definition, so we need to ignore that in the compiler and just go with it
//@ts-ignore
import * as Rusha from "rusha";

export default class HashService implements IHashService {
    public hashFile(file: File, onProgress?: (progress: number) => void): Promise<string> {
        const md = Rusha.createHash();
        const chunksize = 10 * 1024 * 1024; // 10 MiB

        function hashNextPart(offset: number): Promise<number> {
            const nextPart = file.slice(offset, offset + chunksize);
            const newOffset = offset + chunksize;

            return getBlobContent(nextPart).then(content => {
                md.update(content);
                // report progress
                const progress = newOffset < file.size ? newOffset : file.size;
                onProgress?.(progress);
                return newOffset;
            });
        }

        function hashParts(offset: number, resolve: () => void) {
            if (offset >= file.size) {
                resolve();
            } else {
                hashNextPart(offset).then(newOffset => hashParts(newOffset, resolve));
            }
        }

        return new Promise<void>(resolve => hashParts(0, resolve)).then(() => md.digest("hex"));
    }
}

function getBlobContent(blob: Blob): Promise<ArrayBuffer> {
    return new Promise<ArrayBuffer>(resolve => {
        const fr = new FileReader();
        fr.addEventListener("load", () => resolve(fr.result as ArrayBuffer));
        fr.readAsArrayBuffer(blob);
    });
}
